import { Injectable } from '@angular/core';

import { NAVIGATION_ITEMS } from '@tripointe/tripointe-cms/constants';
import { AccessLevel, NavigationItem, PermissionName } from '@tripointe/tripointe-cms/types';
import { Permission } from '@tripointe/tripointe-cms/data-access';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor(private authService: AuthService) {}

  hasPermissionTo(modulePath: PermissionName): boolean {
    return this.getUserPermissionNames().includes(modulePath);
  }

  getPermittedRoutes(): NavigationItem[] {
    const permissionNames = this.getUserPermissionNames();

    return NAVIGATION_ITEMS.filter(navItem => permissionNames.includes(navItem.url));
  }

  private getUserPermissionNames(): string[] {
    return this.authService.getLoggedUserData().permissions.map(permission => permission.name);
  }

  getUserPermissions(): Partial<Permission>[] {
    return this.authService.getLoggedUserData().permissions;
  }

  getUserRole(): AccessLevel {
    return this.authService.getLoggedUserData().role.label as AccessLevel;
  }
}
